import { maxBy as _maxBy } from "lodash";

export function maxBy(array = [], iteratee) {
  return _maxBy(array, iteratee);
}
